import { Action, createReducer, on } from '@ngrx/store';
import * as UserMgmtActions from '../actions';
import { IUserCreate, IUserDetail, IUserList, IUserUpdate } from '../../models/user-mgmt';

const initialState: UserMgmtState = {
  selectedUser: null,
  getUserList: [],
  getUser: null,
  postUser: null,
  patchUser: null,
  getMeUser: null,
  getMeUserLoading: false,
  getMeUserLoaded: false,
};

export interface UserMgmtState {
  selectedUser: IUserDetail | null;
  getUserList: IUserList[];
  getUser: IUserDetail | null;
  postUser: IUserCreate | null;
  patchUser: IUserUpdate | null;
  getMeUser: IUserDetail | null;
  getMeUserLoading: boolean;
  // Whether /me has actually answered in this session. Never persisted, so a
  // rehydrated getMeUser cannot masquerade as a fetched one.
  getMeUserLoaded: boolean;
}

export const userMgmtState = createReducer(
  initialState,
  on(UserMgmtActions.UserMgmtUiActions.SelectUser, (state, { user }) => {
    return {
      ...state,
      selectedUser: user,
    };
  }),

  on(UserMgmtActions.UserMgmtUiActions.GetUsers, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetUserListSuccess, (state, { payload }) => {
    return {
      ...state,
      getUserList: payload,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetUserListFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.GetUser, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetUserSuccess, (state, { payload }) => {
    return {
      ...state,
      getUser: payload,
      selectedUser: payload,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetUserFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.PostUser, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.PostUserSuccess, (state, { payload }: { payload: IUserCreate }) => {
    return {
      ...state,
      postUser: payload,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.PostUserFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.PatchUser, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.UpdateUserSuccess, (state, { payload }) => {
    return {
      ...state,
      patchUser: payload,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.UpdateUserFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.DeleteUser, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.DeleteUserSuccess, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.DeleteUserFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.ReactivateUser, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.ReactivateUserSuccess, (state, { payload }) => {
    return {
      ...state,
      selectedUser: payload,
      getUser: payload,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.ReactivateUserFailure, (state) => {
    return {
      ...state,
    };
  }),
  on(UserMgmtActions.UserMgmtUiActions.GetMeUser, (state) => {
    return {
      ...state,
      getMeUserLoading: true,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetMeUserSuccess, (state, { payload }) => {
    return {
      ...state,
      getMeUser: payload,
      getMeUserLoading: false,
      getMeUserLoaded: true,
    };
  }),
  on(UserMgmtActions.UserMgmtApiActions.GetMeUserFailure, (state) => {
    return {
      ...state,
      getMeUserLoading: false,
    };
  })  
);

export function UserMgmtReducer(state: UserMgmtState = initialState, action: Action): UserMgmtState {
  return userMgmtState(state, action);
}
